import React, { forwardRef } from 'react';
import classnames from 'classnames';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".Radio_radio_CpL05a0EkJ{-webkit-appearance:none;-moz-appearance:none;appearance:none;display:inline-block;vertical-align:middle;width:24px;height:24px;border:1px solid var(--neutral-light,#d5d9de);border-radius:50%;position:relative;outline:none;background:var(--background,#fff)}.Radio_radio_CpL05a0EkJ,.Radio_radio_CpL05a0EkJ *{box-sizing:border-box}.Radio_radio_CpL05a0EkJ:not(:disabled){cursor:pointer}.Radio_radio_CpL05a0EkJ:before{content:\"\";display:block;position:absolute;top:50%;left:50%;transform:translate3d(-50%,-50%,0);width:12px;height:12px;border-radius:50%;background:none}.Radio_radio_CpL05a0EkJ:focus{border-color:var(--secondary-base,#0a7c8e);box-shadow:0 0 0 4px var(--focus,rgba(96,150,230,.75))}.Radio_radio_CpL05a0EkJ.Radio_invalid_os0A0JLJwA{border-color:var(--error-base,#d10f0f)}.Radio_radio_CpL05a0EkJ:checked:before{background:var(--secondary-base,#0a7c8e)}.Radio_radio_CpL05a0EkJ:disabled{cursor:not-allowed;border-color:var(--neutral-light,#d5d9de);background:var(--neutral-light,#d5d9de)}.Radio_radio_CpL05a0EkJ:disabled:checked:before{background:var(--neutral-dark,#a0a5ab)}";
var styles = {"radio":"Radio_radio_CpL05a0EkJ","invalid":"Radio_invalid_os0A0JLJwA"};
styleInject(css_248z);

const Radio = forwardRef((props, ref) => {
    const { className = '', invalid } = props, rest = __rest(props, ["className", "invalid"]);
    const classNames = classnames({
        [styles.radio]: true,
        [styles.invalid]: invalid,
        [className]: className,
    });
    return React.createElement("input", Object.assign({ type: "radio", className: classNames, "aria-invalid": invalid, ref: ref }, rest));
});
Radio.displayName = 'Radio';

export { Radio };
